const apiUrl = process.env.REACT_APP_API_URL;
export const PutHorari = async ( page : string, json: any, id_usu_log : string) => {
    try {
        const response = await fetch(`${apiUrl}:8071/controlhorari/horari/${id_usu_log}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'pantalla': page
            },
            body: JSON.stringify(json)
        });
        if (!response.ok) {
            alert(await response.text());
        }

    } catch (error) {
        console.log('Error al obtener los datos:', error);
    }
};
